import VueRouter from 'vue-router';
import pagenotfound from '@/components/common/pagenotfound';
import PageFrame from '@/components/PageFrame';
import Test from '@/components/page/Test'
import PositionWeb from '@/components/page/PositionWeb.vue';
import FindPositionLite from '@/components/page/FindPositionLite.vue';


// import GlobalStore from './GlobalStore';
// let store = null;

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path : '/',
            component : PageFrame,
            children : [
                {path : '/', component : PositionWeb},
            ]
        },
        {
            path : '/view',
            component : PageFrame,
            children : [
                {path : 'test', component : Test},
                {path : 'position_web', component : PositionWeb},
                {path : 'find_position', component : FindPositionLite},
            ]
        },
        {path: "*", component: pagenotfound }

    ]
});

//페이지화면에서 로그인, 혹은 권한 체크시
router.beforeEach((to, from,next) => {
    if (to.matched.some(route => route.meta.requiresAuth)) {
        // if(!GlobalStore.isLogin()){
        //     GlobalStore.checkLoginAndConfirm(() => {
        //         next()
        //     });
        //     return;
        // }
        // if(localStorage['loginInfo'] != null){

            // if(to.matched.some(route => route.meta.requiresCenter)) {
            //     if (!window.Vue.$cookies.get('center_token')) {
            //         store.commit('showAlert', '센터 지정 후 사용가능합니다.');
            //         if(from.path != '/emptycenter') router.push({ path: '/emptycenter' });
            //         return;
            //     }
            // }
            //
            // next();
        // } else {
        //     next('/login');
        // }
    }
    next();
});

// router.afterEach((to, from) => {
//
// });
//
// router.setStore = function(storeObj){
//     store = storeObj;
// }

export default router;
